module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot4-afc3258b471fbf08df3961b9220ab578.png";